import { TCodec } from "../codec";
import { TError, errorConstants } from "../errors";
import { either } from "fp-ts/lib";
import * as E164PhoneNumber from "../../util/E164PhoneNumber";

export type TAnyPhoneNumberCodec = TCodec<
    "PhoneNumberCodec",
    undefined,
    string ,
    string
>;

const decode = (input: unknown): either.Either<TError, string> => {
    if (typeof input !== "string") {
        return either.left([[errorConstants.REGEX_VALIDATION, ""]]);
    }
    const coerced = E164PhoneNumber.toValidE164OrNull(input);
    return coerced === null
        ? either.left([[errorConstants.REGEX_VALIDATION, ""]])
        : either.right(coerced);
};

const decodeNewDefault = (input: unknown): either.Either<TError, string> =>
    typeof input === "string"
        ? either.right(E164PhoneNumber.fromLocalNumber(input))
        : either.left([[errorConstants.REGEX_VALIDATION, ""]]);

export const phoneNumber = (): TAnyPhoneNumberCodec => ({
    type: "PhoneNumberCodec",
    payload: undefined,
    decode,
    decodeNewDefault,
    newDefault: () => "",
});
